import React from "react";
import { Tabs, Badge } from "antd";
import GemoMed from "./GemoMed";
import GemoFinished from "./GemoFinished";
import { useGetArizaNotFinishedQuery } from "../../redux/gemo/gemo";

function AdminGemo() {
  const { data } = useGetArizaNotFinishedQuery();

  return (
    <div className="oncoAdmin">
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            label: <Badge count={data?.list?.length}>Yangi arizalar</Badge>,
            key: "1",
            children: <GemoMed />,
          },
          {
            label: `Bajarilgan arizalar`,
            key: "2",
            children: <GemoFinished />,
          },
        ]}
      />
    </div>
  );
}

export default AdminGemo;
